import { Button, FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import { Edit } from "@material-ui/icons";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import Api from "../../../../helpers/api";
import { StyledTableCell, StyledTableRow } from "../../containers/StyledTableCell";
import TicketCommentsModal from "../SampleQC/comment";
import { MessageRounded } from "@material-ui/icons";
import {
    createSamplesQc, getProjects, getProjectSampleAllData, getProjectSampleList, getSampleProjectData, updateSamplesQc, uploadMediaFiles
} from "../../store/actions";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        toolbar: {
            alignItems: "center",
            justifyContent: "flex-end",
            padding: theme.spacing(0, 1),
            ...theme.mixins.toolbar,
        },
        content: {
            width: "80%",
            flexGrow: 21,
        },
        textField: {
            marginLeft: theme.spacing(1),
            marginRight: theme.spacing(1),
        },
        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        root1: {
            // backgroundColor: "#fa4d83",

        }
    })
);

interface Props {
    sampleStorageQc: any;
    onBoardingActionType: any;
    projects: any;
    getProjects: any;
    getProjectSampleList: any;
    sapmleList: any;
    sampleAllData: any;
    getProjectSampleAllData: any;
    createSamplesQc: any;
    uploadMediaFiles: any;
    mediaUpload: any;
    fetchsamplepdata: any;
    getSampleProjectData: any;
    updateSamplesQc: any;
}
const StopsPlace: React.FC<Props> = ({
    projects,
    getProjects,
    sampleAllData,
    getProjectSampleAllData,
    createSamplesQc,
    fetchsamplepdata,
    getSampleProjectData,
    updateSamplesQc,
}) => {
    const classes = useStyles();
    const timer = useRef<any>(0);
    const [dnaStatus, setDnaStatus] = useState<any>("");
    const [key, setKey] = useState<any>(true);
    const [fileKey, setFileKey] = useState<string>(Math.random().toString(36));
    const [rinValue, setRinValue] = useState<any>("");
    const [isolation, setIsolation] = useState<any>("");
    const [volume, setVolume] = useState<any>("");
    const [yields, setYields] = useState<any>("");
    const [ratio, setRatio] = useState<any>("")
    const [isEdit, setIsEdit] = useState<any>(false);
    const [concn, setConcn] = useState<any>("");
    const [page, setPage] = useState(0);
    const [kitName, setKitName] = useState<any>("");
    const [ratioData, setRatioData] = useState<any>("");
    const { id } = useParams<{ id: string }>();
    const [projectId, setProjectId] = useState<any>("");
    const [remarks, setRemarks] = useState<any>("");
    const [sampleStatus, setSampleStatus] = useState<any>("");
    const [sampleId, setSampleId] = useState<any>("");
    const [sample, setSample] = useState<any>();
    const [displaySample, setDisplaySample] = useState<string>("");
    const [projectname, setProjectName] = useState<any>("");
    const [project, setProject] = useState<any>("");
    const [uploading, setUploading] = useState<boolean>(false);
    const [dev, setDev] = useState<any>("");
    const [comment, setComment] = useState<any>("");
    const [openModal, setopenModal] = useState<boolean>(false);
    const [runData, setRunData] = useState<any>("")
    const [mediaFile, setMediaFile] = useState<any>({
        "qcimage": "",
        "qcreport": "",
    });

    const fileSelectedHandler = async (e: React.ChangeEvent<{ files: any }>, type: any) => {
        const formData = new FormData();
        formData.append("file", e.target.files[0]);
        setUploading(true);
        Api.post("/media", formData).then((data: any) => {
            setMediaFile({
                ...mediaFile,
                [type]: data?.path,
            })
            setUploading(false);
        }).catch(() => {
            setUploading(false);
        });
    };

    let [fetchSampleQcData, setFetchSampleQcData] = useState<any>([]);

    useEffect(() => {
        let storeData: any = [];
        if (fetchsamplepdata && fetchsamplepdata?.results?.length > 0 && project)
            fetchsamplepdata?.results?.filter((data: any) => data?.qc).map((data: any) => {
                storeData.push({
                    ...data,
                })
            })

        setFetchSampleQcData(storeData);
    }, [fetchsamplepdata, project])

    useEffect(() => {
        if (project !== "") {
            getProjectSampleAllData(`?qcCompleted=false&stored=true&project=${project}`);
            getSampleProjectData(`?project=${project}`);
        }
    }, [project])


    const handleAddSequence = async (e: any) => {
        e.preventDefault();
        const filterPath = mediaFile
        const sampleQcdata = {
            project_id: projectId,
            sample_id: sampleId,
            isolationMethod: isolation,
            concentration: concn,
            volume: volume,
            totalYield: yields,
            ratio260By280: ratio,
            ratio260By230: ratioData,
            rinDin: rinValue,
            sampleType: dnaStatus,
            qcStatus: sampleStatus,
            qcImage: filterPath?.qcimage,
            qcReport: filterPath?.qcreport,
            kitName: kitName,
            dv200: dev,
            comment: comment,

        }
        if (sample && sampleQcdata && isEdit === false) {
            await createSamplesQc(sample, sampleQcdata);
            getProjectSampleAllData(`?qcCompleted=false&project=${project}`);
        } else if (isEdit === true) {
            await updateSamplesQc(sample, sampleQcdata);
        }
        getSampleProjectData(`?project=${project}`);
        setIsEdit(false);
        setSample("");
        setDisplaySample("");
        setIsolation("");
        setConcn("");
        setVolume("");
        setKitName("");
        setYields("");
        setRatio("");
        setRatioData("");
        setRinValue("");
        setSampleStatus("");
        setSample("");
        setDnaStatus("");
        setMediaFile("");
        setComment("");
        setDev("");
        setFileKey(Math.random().toString(36));
    };
    const handleEdit = (val: any) => {
        setIsEdit(true);
        setSample(val?._id);
        setDisplaySample(val?.name);
        setIsolation(val?.qc?.isolationMethod);
        setConcn(val?.qc?.concentration);
        setVolume(val?.qc?.volume);
        setKitName(val?.qc?.kitName);
        setYields(val?.qc?.totalYield);
        setRatio(val?.qc?.ratio260By280);
        setRatioData(val?.qc?.ratio260By230);
        setRinValue(val?.qc?.rinDin);
        setSampleStatus(val?.qc?.qcStatus);
        setDnaStatus(val?.qc?.sampleType);
        setDev(val?.qc?.dv200);
        setComment(val?.qc?.comment);
        setMediaFile(
            {
                "qcimage": (val?.qc?.qcImage),
                "qcreport": (val?.qc?.qcReport)
            }
        )
        setKey(!key);
    };
    const handleClick = (data: any) => {
        setopenModal(true);
        setRunData(data);
    };

    useEffect(() => {
        if(concn && volume) {
            setYields(concn * volume);
        }
    }, [concn, volume])

    return (
        <Grid container spacing={2}>
            <form onSubmit={handleAddSequence} style={{ width: "100%" }}>
                <Paper style={{ margin: "70px auto", width: "100%", marginTop: 10 }} className={classes.root1}>
                    {isEdit === false ?
                        <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Sample QC</h2>
                        : ""}
                    {isEdit === true ?

                        <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Edit Sample QC</h2>
                        : ""}
                    <Grid container spacing={2} style={{ marginLeft: 1 }}>
                        <Grid item xs={12} sm={4} md={2}>
                            <Autocomplete
                                id="Project"
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        setProject(newValue?._id);
                                    } else {
                                        setProject("")
                                    }
                                }}
                                options={projects?.results || []}
                                blurOnSelect
                                getOptionLabel={(option: any) => {
                                    return (
                                        (option?.projectId) +
                                        " " +
                                        (option?.institute?.name || "") +
                                        " " +
                                        (option?.scientist?.name || "") +
                                        "," +
                                        (option?.dealer?.firmName || "")
                                    );
                                }}
                                onInputChange={(event, newInputValue) => {
                                    let data = newInputValue.split(" ");
                                    clearTimeout(timer.current);
                                    timer.current = setTimeout(() => {
                                        if (data.length > 0) {
                                            getProjects(`?projectId=${data[0]}`);
                                        }
                                    }, 1000);
                                    setProjectName(newInputValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        className="input"
                                        label="Project"
                                        placeholder="Search ID/Client/Dealer Name"
                                        variant="outlined"
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <Autocomplete
                                id="sample"
                                onChange={(event, newValue) => {
                                    setSample(newValue?._id);
                                }}
                                options={sampleAllData?.results || []}
                                blurOnSelect
                                getOptionLabel={(option: any) => `${option?.name}`}
                                inputValue={displaySample}
                                onInputChange={(event, newInputValue) => {
                                    setDisplaySample(newInputValue)
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        className="input"
                                        label="Sample Names"
                                        placeholder="Select Sample Name"
                                        variant="outlined"
                                        required
                                        fullWidth
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Isolation Method*</InputLabel>
                                <Select
                                    label="Isolation Method"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    required
                                    value={isolation || "none"}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={(e) => setIsolation(e.target.value)}
                                >
                                    <MenuItem value="none" disabled><em>Select Isolation Method</em></MenuItem>
                                    <MenuItem value="Kit Based"> Kit Based </MenuItem>
                                    <MenuItem value="Manual"> Manual </MenuItem>
                                    <MenuItem value="Others"> Others </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        {isolation === "Kit Based" ?
                            <Grid item xs={12} sm={4} md={2}>
                                <TextField
                                    label="Kit Name"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    placeholder="Enter Kit Name"
                                    value={kitName}
                                    onChange={(e) => setKitName(e.target.value)}
                                />
                            </Grid>
                            : ""}
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                key={key}
                                label="Concn(ng/ul)"
                                variant="outlined"
                                className="input"
                                placeholder="Enter Concn(ng/ul)"
                                fullWidth
                                value={concn}
                                required
                                onChange={(e) => setConcn(e.target.value.replace(/\s/g, ''))}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Volume"
                                variant="outlined"
                                className="input"
                                fullWidth
                                placeholder=" Enter Volume"
                                value={volume}
                                required
                                onChange={(e) => setVolume(e.target.value.replace(/\s/g, ''))}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="Total Yield"
                                variant="outlined"
                                className="input"
                                fullWidth
                                placeholder="Enter Total Yield"
                                value={yields} 
                                disabled
                                required
                                onChange={(e) => setYields(e.target.value.replace(/\s/g, ''))}                             
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="260/280 Ratio"
                                variant="outlined"
                                className="input"
                                fullWidth
                                placeholder="Enter 260/280 Ratio"
                                value={ratio}
                                required
                                onChange={(e) => setRatio(e.target.value.replace(/\s/g, ''))}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                label="230/260 Ratio"
                                variant="outlined"
                                className="input"
                                fullWidth
                                placeholder="Enter 230/260 Ratio"
                                value={ratioData}
                                onChange={(e) => setRatioData(e.target.value.replace(/\s/g, ''))}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Sample Type*</InputLabel>
                                <Select
                                    label="Sample Type"
                                    variant="outlined"
                                    className="input"
                                    placeholder="Select Type"
                                    fullWidth
                                    required
                                    value={dnaStatus || "none"}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={(e) => setDnaStatus(e.target.value)}
                                >
                                    <MenuItem value="none" disabled><em>Select Type</em></MenuItem>
                                    <MenuItem value="RNA"> RNA </MenuItem>
                                    <MenuItem value="DNA"> DNA </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>RIN/DIN Value*</InputLabel>
                                <TextField
                                    label="RIN/DIN Value"
                                    variant="outlined"
                                    className="input"
                                    type="number"
                                    fullWidth
                                    placeholder="Enter RIN/DIN Value"
                                    value={rinValue}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={(e) => setRinValue(e.target.value)}
                                />

                            </FormControl>
                        </Grid>
                        {dnaStatus === "RNA" ?
                            <Grid item xs={12} sm={4} md={2}>
                                <TextField
                                    label="Dev200"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    placeholder="Enter Dev200"
                                    value={dev}
                                    onChange={(e) => setDev(e.target.value)}
                                    required
                                />
                            </Grid>
                            : ""}
                        <Grid item xs={12} sm={4} md={2}>
                            <FormControl style={{ width: "100%" }} className="input">
                                <InputLabel>Sample Status*</InputLabel>
                                <Select
                                    label="Sample Status"
                                    variant="outlined"
                                    className="input"
                                    fullWidth
                                    required
                                    value={sampleStatus || "none"}
                                    style={{ width: "100%", height: "40px" }}
                                    onChange={(e) => setSampleStatus(e.target.value)}
                                >
                                    <MenuItem value="none" disabled><em>Select Sample Status</em></MenuItem>
                                    <MenuItem value="Pass">Pass </MenuItem>
                                    <MenuItem value="Fail">Fail</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        {sampleStatus === "Fail" ?
                            <Grid item xs={12} sm={4} md={2}>
                                <TextField
                                    fullWidth
                                    id="outlined-basic"
                                    label="Remarks"
                                    variant="outlined"
                                    className="input"
                                    placeholder="Type Remarks"
                                    value={remarks}
                                    onChange={(e) => setRemarks(e.target.value)}
                                />
                            </Grid>
                            : " "}
                        <Grid item xs={12} sm={4} md={2}>
                            <TextField
                                id="filled-number"
                                className="input"
                                label="Comment"
                                fullWidth
                                value={comment}
                                placeholder="type Comments"
                                variant="outlined"
                                onChange={(e) => setComment(e.target.value)}

                            />
                        </Grid>
                        {/* <Grid item xs={12} sm={4} md={3}>
                            <sup
                                style={{
                                    fontSize: "11px",
                                    marginLeft: "15px",
                                    marginTop: "15px",
                                    background: "#fff",
                                    color: "rgba(0, 0, 0, 0.54)",
                                    letterSpacing: "0.00938em",
                                }}
                            >

                                Sample QC Image

                            </sup>
                            <input
                                className={classes.input}
                                style={{
                                    width: "100%",
                                    height: "46px",
                                    marginTop: "-15px",
                                    padding: "11.5px 14px",
                                    border: "1px solid rgba(0, 0, 0, 0.23)",
                                    borderRadius: "5px",
                                }}
                                type="file"
                                name="file"
                                id="file"
                                key={`${fileKey}qcimage`}
                                onChange={(e: any) => fileSelectedHandler(e, "qcimage")}

                            />
                        </Grid> */}
                        {/* <Grid item xs={12} sm={4} md={3}>
                            <sup
                                style={{
                                    fontSize: "11px",
                                    marginLeft: "15px",
                                    marginTop: "15px",
                                    background: "#fff",
                                    color: "rgba(0, 0, 0, 0.54)",
                                    letterSpacing: "0.00938em",
                                }}
                            >
                                Sample QC Report
                            </sup>
                            <input
                                className={classes.input}
                                style={{
                                    width: "100%",
                                    height: "46px",
                                    marginTop: "-15px",
                                    padding: "11.5px 14px",
                                    border: "1px solid rgba(0, 0, 0, 0.23)",
                                    borderRadius: "5px",
                                }}
                                type="file"
                                name="file"
                                id="file"
                                key={`${fileKey}qcreport`}
                                onChange={(e: any) => fileSelectedHandler(e, "qcreport")}

                            />
                        </Grid> */}
                        <Grid item xs={12} sm={4} md={2}>
                            <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                                style={{ height: "46px", marginTop: 7 }}
                                fullWidth
                                disabled={uploading}
                            >
                                {isEdit ? "Update" : "Add"}
                            </Button>
                        </Grid>
                    </Grid>
                    <div style={{ width: "100%" }}>
                        <TableContainer className={classes.tableContainer} component={Paper} style={{ maxHeight: "550px" }}>
                            <Table stickyHeader aria-label="simple table">
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell align="center">Sample Name</StyledTableCell>
                                        <StyledTableCell align="center">Isolation Method</StyledTableCell>
                                        <StyledTableCell align="center">Isolation Date</StyledTableCell>
                                        <StyledTableCell align="center">Concn(ng/ul)</StyledTableCell>
                                        <StyledTableCell align="center">Volume</StyledTableCell>
                                        <StyledTableCell align="center">Total Yield</StyledTableCell>
                                        <StyledTableCell align="center">260/280 Ratio</StyledTableCell>
                                        <StyledTableCell align="center">260/230 Ratio</StyledTableCell>
                                        <StyledTableCell align="center">RIN/DIN Value</StyledTableCell>
                                        <StyledTableCell align="center">Sample Type</StyledTableCell>
                                        <StyledTableCell align="center">Sample QC Status</StyledTableCell>
                                        {/* <StyledTableCell align="center">Sample QC Image</StyledTableCell> */}
                                        {/* <StyledTableCell align="center">Sample QC Report</StyledTableCell> */}
                                        <StyledTableCell align="center">Comment</StyledTableCell>
                                        <StyledTableCell align="center">Edit</StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                    {fetchSampleQcData?.map((data: any, index: any) => {
                                        {
                                        }
                                        return (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell align="center">{data?.name}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.qc?.isolationMethod}</StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {data?.createdAt !== null ? new Date(data?.qc?.createdAt).toLocaleString() : "NA"}
                                                </StyledTableCell>
                                                <StyledTableCell align="center">{data?.qc?.concentration}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.qc?.volume}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.qc?.totalYield}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.qc?.ratio260By280}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.qc?.ratio260By230}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.qc?.rinDin}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.qc?.sampleType}</StyledTableCell>
                                                <StyledTableCell align="center">{data?.qc?.qcStatus}</StyledTableCell>
                                                {/* <StyledTableCell align="center">
                                                    {data?.qc?.qcImage === "" ? ""
                                                        : <a href={data?.qc?.qcImage} target="_blank" rel="noopener noreferrer">View</a>}
                                                </StyledTableCell> */}
                                                {/* <StyledTableCell align="center">
                                                    {data?.qc?.qcReport !== "" ?
                                                        <a href={data?.qc?.qcReport} target="_blank" rel="noopener noreferrer">View</a>
                                                        : ""}
                                                </StyledTableCell> */}
                                                <StyledTableCell align="center">
                                                    {data?.qc?.comment === "" ? "" :
                                                    <div>
                                                        <MessageRounded
                                                            onClick={() => handleClick(data)}
                                                        />
                                                    </div>
                                    }
                                                </StyledTableCell>
                                                <StyledTableCell align="center">
                                                    <Button
                                                        color="primary"
                                                        variant="contained"
                                                    >
                                                        <Edit onClick={() => handleEdit(data)} />
                                                    </Button>
                                                </StyledTableCell>

                                            </StyledTableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TicketCommentsModal
                            openModal={openModal}
                            setopenModal={setopenModal}
                            rundata={runData}
                        />
                    </div>
                </Paper>
            </form>
        </Grid >

    );
};
const mapStateToProps = (state: any) => ({
    projects: state.GenomicsLabReducer.projects,
    sapmleList: state.GenomicsLabReducer.sapmleList,
    sampleAllData: state.GenomicsLabReducer.sampleAllData,
    mediaUpload: state.GenomicsLabReducer.mediaUpload,
    fetchsamplepdata: state.GenomicsLabReducer.fetchsamplepdata,

});
export default connect(mapStateToProps, {
    getProjects,
    getProjectSampleList,
    getProjectSampleAllData,
    createSamplesQc,
    uploadMediaFiles,
    getSampleProjectData,
    updateSamplesQc,
})(StopsPlace);
